import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import EmployeeConfig from '../../../services/api/EmployeeConfig'
import RestClient from '../../../services/client/RestClient'

const { Import_Users_Roles_Endpoints } = EmployeeConfig

export const importUsersRolesResetAlertHandler = createAsyncThunk(
  'importUsersRoles/importUsersRolesResetAlertHandler',
  async () => ({}),
)
export const importUsersRolesCreateFile = createAsyncThunk(
  'importUsersRoles/importUsersRolesCreateFile',
  async ({ queries }, { rejectWithValue }) => {
    const apiUri = Import_Users_Roles_Endpoints()
    const formData = new FormData()
    formData.append('file', queries?.file)
    const response = await axios.post(`${apiUri.createFile}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)

export const importUsersRolesGetRoles = createAsyncThunk(
  'importUsersRoles/importUsersRolesGetRoles',
  async (_, { rejectWithValue }) => {
    const apiUri = Import_Users_Roles_Endpoints()
    const response = await RestClient.getRequest(`${apiUri.getRoles}`)
    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)

export const importUsersRolesSearchRoles = createAsyncThunk(
  'importUsersRoles/importUsersRolesSearchRoles',
  async ({ queries }, { rejectWithValue }) => {
    const apiUri = Import_Users_Roles_Endpoints()
    const response = await RestClient.getRequest(`${apiUri.getRoles}?search=${queries || ''}`)
    if (response.status >= 300) {
      return rejectWithValue(response)
    }
    return response.data
  },
)
